import { combineReducers } from 'redux'
import { DEFAULT_PAGINATION_ENTRIES } from 'services/api'
import { getType } from 'typesafe-actions'

import {
  DealManagerAction,
  deleteDeal,
  fetchDraftUserGroups,
  fetchDraftUsers,
  fetchManagerPairings,
  resetFilters,
  unMountPairingManager,
  updateCurrentPage,
  updateFinderStagesFilter,
  updateIsValidFilter,
  updateOrganizationFilter,
  updateSearchCount,
  updateSearchRequestIdFilter,
  updateCorporateFilter,
  updateCorporateStatusFilter,
} from './actions'
import { DealManagerState, IsValidFilter, PairingManagerFilters, CorporateStatusFilter } from './types'

export const filterReducer = combineReducers<PairingManagerFilters, DealManagerAction>({
  organizationSearch: (organizationSearch = null, action) => {
    switch (action.type) {
      case getType(resetFilters):
        return null
      case getType(updateOrganizationFilter):
        return action.payload
      default:
        return organizationSearch
    }
  },
  corporateSearch: (corporateSearch = null, action) => {
    switch (action.type) {
      case getType(resetFilters):
        return null
      case getType(updateCorporateFilter):
        return action.payload
      default:
        return corporateSearch
    }
  },
  scoutingCampaignId: (scoutingCampaignId = null, action) => {
    switch (action.type) {
      case getType(resetFilters):
        return null
      case getType(updateSearchRequestIdFilter):
        return action.payload
      default:
        return scoutingCampaignId
    }
  },
  isValidFilter: (isValid = IsValidFilter.all, action) => {
    switch (action.type) {
      case getType(resetFilters):
        return IsValidFilter.all
      case getType(updateIsValidFilter):
        return action.payload
      default:
        return isValid
    }
  },
  currentPage: (currentPage = 0, action) => {
    switch (action.type) {
      case getType(updateSearchCount):
      case getType(updateOrganizationFilter):
      case getType(updateCorporateFilter):
      case getType(updateCorporateStatusFilter):
      case getType(resetFilters):
        return 0
      case getType(updateCurrentPage):
        return action.payload
      default:
        return currentPage
    }
  },
  corporateStatusFilter: (
    corporateStatus: CorporateStatusFilter = CorporateStatusFilter.active,
    action
  ): CorporateStatusFilter => {
    switch (action.type) {
      case getType(updateCorporateStatusFilter):
        return action.payload
      default:
        return corporateStatus
    }
  },
  limit: (limit = DEFAULT_PAGINATION_ENTRIES, action) => {
    switch (action.type) {
      case getType(updateSearchCount):
        return action.payload
      default:
        return limit
    }
  },
  finderStagesFilter: (finderStages = [], action) => {
    switch (action.type) {
      case getType(updateFinderStagesFilter):
        return action.payload
      default:
        return finderStages
    }
  },
})

export const dealManagerReducer = combineReducers<DealManagerState, DealManagerAction>({
  dealsOrder: (dealsOrder = [], action) => {
    switch (action.type) {
      case getType(unMountPairingManager):
        return []
      case getType(fetchManagerPairings.success):
        return action.payload
      case getType(fetchManagerPairings.request):
      case getType(fetchManagerPairings.cancel):
        return []
      case getType(deleteDeal): {
        const deal = action.payload
        return dealsOrder.filter((d) => d.id !== deal.id)
      }
      default:
        return dealsOrder
    }
  },
  users: (users = {}, action) => {
    switch (action.type) {
      case getType(unMountPairingManager):
        return {}
      case getType(fetchDraftUsers.success):
        return action.payload
      default:
        return users
    }
  },
  userGroups: (userGroups = {}, action) => {
    switch (action.type) {
      case getType(unMountPairingManager):
        return {}
      case getType(fetchDraftUserGroups.success):
        return action.payload
      default:
        return userGroups
    }
  },
  isLoading: (isLoading = false, action) => {
    switch (action.type) {
      case getType(unMountPairingManager):
        return false
      case getType(fetchManagerPairings.request):
        return true
      case getType(fetchManagerPairings.failure):
      case getType(fetchManagerPairings.success):
      case getType(fetchManagerPairings.cancel):
        return false
      default:
        return isLoading
    }
  },
  filters: filterReducer,
})
